import { createTheme } from "@mui/material";
import { arEG } from "@mui/material/locale";

// create theme
export const MuiTheme = createTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#0049ad",
          light: "#0049ad",
        },
        secondary: {
          main: "#48AA6D",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: "#0049ad",
          light: "#0049ad",
        },
        secondary: {
          main: "#48AA6D",
        },
      },
    },
  },
  typography: {
    fontFamily: ["Cairo"].join(","),
  },
});
